export default "__VITE_ASSET__BQKEinOD__"